import React from 'react';
import { Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'gold' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  href?: string;
  fullWidth?: boolean;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  href,
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-navy-900 text-white hover:bg-navy-800 focus-visible:ring-navy-900',
    secondary: 'bg-navy-700 text-white hover:bg-blue-700 focus-visible:ring-navy-700',
    outline: 'border-2 border-navy-900 text-navy-900 hover:bg-navy-50 focus-visible:ring-navy-900',
    gold: 'bg-gold-500 text-white hover:bg-gold-600 focus-visible:ring-gold-500',
    ghost: 'hover:bg-gray-100 text-gray-700'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  if (href) {
    return <Link to={href} className={combinedClassName} data-id="element-94" data-mp="12lihta8rrecg">
        {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-95" data-mp="xnquktj2kgel" />}
        {children}
      </Link>;
  }
  return <button className={combinedClassName} disabled={isLoading} {...props} data-id="element-96" data-mp="1ccvce9lycim6">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-97" data-mp="17fmqbxxonufn" />}
      {children}
    </button>;
}